// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__uRJIQ"};